import React from 'react';

const Footer = () => (
  <div className="footer">
    <div className="flex gap-x-2 items-center text-center lg:text-[20px] top-[100px] footer-cont relative lg:left-[450px]">
      <p className="text-[#fff] mb-10">Copyright © 2022 </p>
      <a href="https://github.com/KingsleyIbe" target="_blank" className="text-[#ff6b00] mb-10" rel="noreferrer">Kingsley Ibe</a>
      <p className="text-[#fff] mb-10">All Rights Reserved</p>
    </div>
  </div>
);

export default Footer;
